// Producer-vibe stock photos from Unsplash paired with legendary producer names.
// Note: Photos are royalty-free studio/DJ/producer stock — NOT likenesses of the named artists.
export const LEGENDS = [
  {
    name: "Dr. Dre",
    era: "1988 — PRESENT",
    tagline: "West coast architect. Turned drum machines into cathedrals.",
    image:
      "https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=900&q=80&auto=format&fit=crop",
  },
  {
    name: "Timbaland",
    era: "1996 — PRESENT",
    tagline: "Percussion alien. Rewrote the pocket for R&B and hip-hop.",
    image:
      "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=900&q=80&auto=format&fit=crop",
  },
  {
    name: "Metro Boomin",
    era: "2013 — PRESENT",
    tagline: "808 wizard. Made 'if young Metro don't trust you' a warning shot.",
    image:
      "https://images.unsplash.com/photo-1571330735066-03aaa9429d89?w=900&q=80&auto=format&fit=crop",
  },
  {
    name: "Kanye West",
    era: "2000 — PRESENT",
    tagline: "Soul-chop pioneer. Turned every sample into a monument.",
    image:
      "https://images.unsplash.com/photo-1516280440614-37939bbacd81?w=900&q=80&auto=format&fit=crop",
  },
  {
    name: "Rick Rubin",
    era: "1984 — PRESENT",
    tagline: "The reducer. Strips songs until only the truth remains.",
    image:
      "https://images.unsplash.com/photo-1508700115892-45ecd05ae2ad?w=900&q=80&auto=format&fit=crop",
  },
  {
    name: "Pharrell",
    era: "1992 — PRESENT",
    tagline: "The Neptunes minimalist. Four notes, whole eras.",
    image:
      "https://images.unsplash.com/photo-1520166012956-add9ba0835cb?w=900&q=80&auto=format&fit=crop",
  },
  {
    name: "J Dilla",
    era: "1992 — 2006",
    tagline: "The drunk drummer swing. Off-grid MPC feel that rewired hip-hop.",
    image:
      "https://images.unsplash.com/photo-1493421419110-74f4e85ba126?w=900&q=80&auto=format&fit=crop",
  },
  {
    name: "Madlib",
    era: "1993 — PRESENT",
    tagline: "The beat konducta. Crate-dug loops from planets no one's been to.",
    image:
      "https://images.unsplash.com/photo-1462965326201-d02e4f455804?w=900&q=80&auto=format&fit=crop",
  },
  {
    name: "Quincy Jones",
    era: "1953 — PRESENT",
    tagline: "The maestro. From bebop to Thriller — every ceiling raised.",
    image:
      "https://images.unsplash.com/photo-1459749411175-04bf5292ceea?w=900&q=80&auto=format&fit=crop",
  },
  {
    name: "9th Wonder",
    era: "1999 — PRESENT",
    tagline: "Soul chop scholar. Built classics inside FL Studio's default settings.",
    image:
      "https://images.unsplash.com/photo-1478147427282-58a87a120781?w=900&q=80&auto=format&fit=crop",
  },
  {
    name: "DJ Premier",
    era: "1985 — PRESENT",
    tagline: "The scratch hook king. Every boom-bap head owes him rent.",
    image:
      "https://images.unsplash.com/photo-1487180144351-b8472da7d491?w=900&q=80&auto=format&fit=crop",
  },
  {
    name: "The Alchemist",
    era: "1991 — PRESENT",
    tagline: "Cinematic loops, dusty samples. Made grimy sound expensive.",
    image:
      "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=900&q=80&auto=format&fit=crop",
  },
];
